module.exports = __webpack_public_path__ + "static/media/social-signup-hero.e3949a63.png";